export const environment = {
  production: false,
  auth0: {
    clientID: 'XbblpPJFvZ3Wh02OkI8wfZfd82cvuzjr',
    domain: 'much-smarter-student.auth0.com',
    audience: 'https://much-smarter-student.auth0.com/api/v2/',
    grant_type: 'http://auth0.com/oauth/grant-type/password-realm',
    loginUrl: 'https://much-smarter-student.auth0.com/oauth/token',
    realm: 'Username-Password-Authentication',
    logoutUrl: 'https://much-smarter-student.auth0.com/v2/logout?returnTo=',
    signUpUrl: 'https://much-smarter-student.auth0.com/dbconnections/signup',
    resetPasswordUrl:
      'https://much-smarter-student.auth0.com/dbconnections/change_password',
    // redirectUri: '/callback',
  },
  contentful: {
    space: 'g4fd7ikht5xp',
    accessToken:
      '209fc163c6fd7239a0f7838ceb3bafed37b03c22da72732f986d4e4222d46856',
    help: {
      space: '9volucx024w8',
      accessToken:
        'ee2661b1825d883fc30a7acb53602b412f8c12574eb340875710a0211e3856f0',
    },
  },
  msStudentApiUrl: 'https://api-ms.wtt-solutions.net/student/',
  instabugToken: 'cfe1ff8d7f21dffb4b24c801c3eb6803',
  defaultCourseId: 6,
  intercom: {
    appId: 'xbx8wi7f',
  },
  googleAnalytics: {
    trackingId: 'UA-46989702-1',
  },
  // Old US test account — tokens from this key fail against sandbox sk_test_51I3iy8.
  // 'pk_test_51HX6ZhLNRDOJCR5mDuYC1udQj2hds0tet3efwZJIY2DCRifNsLozye2T25JbphaXKCdNWnk3yC1scjCgYJCSSEPP00R18Q5tNo'
  stripePublishableKey:
    'pk_test_51I3iy8CueBjnI1nGflKlGRKSTldyGtI4wlvBxyw9yWWDw4h7dC70kGi21HqFY3F0416RXk2JGhGOOPy9kuHbuzXa00puAbXJTW',
};
